var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{..._vm.classes}},[_vm._t("default"),(_vm.stringContent)?_c('span',[_vm._v(_vm._s(_vm.stringContent))]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }